import { Logger } from './logger';

export default class NullLogger implements Logger {
  updateFromMetaData(): void {}

  debug(): void {}

  error(): void {}
}
